export default __webpack_public_path__ + "static/media/bucket.efd58e82.png";